"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Headers = require("../../Headers");

var _Features = require("../../Features");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var BlogTemplate = function BlogTemplate(_ref) {
  var HeaderProps = _ref.HeaderProps,
      FeatureProps = _ref.FeatureProps,
      FeatureWrapper = _ref.FeatureWrapper,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Headers.Mast, HeaderProps), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    py: 4
  }, /*#__PURE__*/_react["default"].createElement(_core.Container, {
    maxWidth: "md"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mb: 5
  }, children), /*#__PURE__*/_react["default"].createElement(FeatureWrapper, null, /*#__PURE__*/_react["default"].createElement(_Features.Field, FeatureProps)))));
};

BlogTemplate.defaultProps = {
  FeatureProps: {},
  FeatureWrapper: function FeatureWrapper(props) {
    return /*#__PURE__*/_react["default"].createElement('div', props);
  }
};
BlogTemplate.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  HeaderProps: _propTypes["default"].object.isRequired,
  children: _propTypes["default"].node.isRequired,
  FeatureProps: _propTypes["default"].shape({
    title: _propTypes["default"].string,
    lists: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      title: _propTypes["default"].string,
      description: _propTypes["default"].string,
      src: _propTypes["default"].string,
      onClick: _propTypes["default"].func
    })).isRequired
  }),
  FeatureWrapper: _propTypes["default"].func
};
var _default = BlogTemplate;
exports["default"] = _default;